import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Loader({ className }: { className?: string }) {
  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <Loader2 className={cn("text-muted-foreground size-6 animate-spin", className)} />
    </div>
  );
}

/** Full-viewport fallback for route-level Suspense boundaries. */
export function PageLoader() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <Loader2 className="text-muted-foreground size-8 animate-spin" />
    </div>
  );
}
